import type { CSSProperties } from 'react';
import { Box, Skeleton } from '@mui/material';

interface ChartCardSkeletonProps {
  height?: CSSProperties['height'];
}

export const ChartCardSkeleton = ({ height = 280 }: ChartCardSkeletonProps) => (
  <Box
    aria-hidden="true"
    data-testid="chart-card-skeleton"
    sx={{
      border: 1,
      borderColor: 'divider',
      borderRadius: 2,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      height,
      minWidth: 0,
      p: { xs: 2, sm: 2.5 },
      width: '100%',
    }}
  >
    <Skeleton variant="text" width="44%" />
    <Skeleton sx={{ flex: 1, minHeight: 120, mt: 2 }} variant="rounded" width="100%" />
    <Skeleton sx={{ mt: 1.5 }} variant="text" width="68%" />
  </Box>
);

export default ChartCardSkeleton;
